import { render, staticRenderFns } from "./WrapperSendDocumentDrawer.vue?vue&type=template&id=23dcbc14&scoped=true"
import script from "./WrapperSendDocumentDrawer.vue?vue&type=script&lang=js"
export * from "./WrapperSendDocumentDrawer.vue?vue&type=script&lang=js"
import style0 from "./WrapperSendDocumentDrawer.vue?vue&type=style&index=0&id=23dcbc14&prod&lang=scss&scoped=true"
import style1 from "./WrapperSendDocumentDrawer.vue?vue&type=style&index=1&id=23dcbc14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dcbc14",
  null
  
)

export default component.exports